<script>
import { mapActions } from 'vuex'
import { apiI18n } from '../constants/global/data'

export default {
  methods: {
    ...mapActions([
      'addToastAction'
    ]),
    addToast (type, content) {
      if (content.message_code) {
        if (apiI18n[content.message_code]) {
          content = apiI18n[content.message_code]['zh-TW']
        } else if (content.message) {
          content = content.message
        } else {
          content = content.message_code
        }
      }
      let data = {
        type: type,
        content: content
      }
      this.addToastAction(data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/toastMethods.vue